// import "@/styles/globals.css";
"use client";
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import Footer from "@/components/FooterBar";
import { useEffect } from "react";
import "@/app/styles/globals.scss";
config.autoAddCss = false;

export default function RootLayout({ children }) {
  useEffect(() => {
    const disableContextMenuOnImages = (e) => {
      if (e.target.tagName === "IMG") {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", disableContextMenuOnImages);

    return () => {
      document.removeEventListener("contextmenu", disableContextMenuOnImages);
    };
  }, []);
  return (
    <main>
      {/* <Navbar />   */}
      {children}
      {/* <Footer /> */}
    </main>
  );
}
